<script>
  import { onDestroy, createEventDispatcher } from 'svelte';
  import { addChannel, listenToChannelsWhere, setMultichannelChatConfig } from '../../../Api/api';
  import CreateChannel from './CreateChannel.svelte';
  import {
    categories,
    channelFilterText,
    selectedChannelTypeFilter,
    showArchivedChannels,
    showOnlyMyChannels,
    user,
  } from '../../../Store/store';
  import Link from 'svelte-routing/src/Link.svelte';
  import { fade } from 'svelte/transition';
  import { link, navigate } from 'svelte-routing';
  import Filter from './Filter.svelte';
  import ChannelsList from './ChannelsList.svelte';

  const dispatch = createEventDispatcher();

  export let standAlone = false;

  let unsubscribeListenToChannels;
  let createChannelOpen = false;
  let isCreatingChannel = false;
  let allChannels = [];
  $: channels = [];
  $: $categories.length && listenToChannelData();

  onDestroy(async () => {
    if (unsubscribeListenToChannels) {
      unsubscribeListenToChannels();
    }
  });

  const listenToChannelData = async (e) => {
    channels = [];
    if (unsubscribeListenToChannels) {
      unsubscribeListenToChannels();
    }
    unsubscribeListenToChannels = await listenToChannelsWhere(
      $showArchivedChannels,
      (snapShot) => {
        const channelData = [];
        snapShot.forEach((doc) => {
          channelData.push({ ...doc.data(), id: doc.id });
        });
        const sorted = channelData
          .sort((a, b) => {
            const dateA = a.created ? a.created.toDate() : 0;
            const dateB = b.created ? b.created.toDate() : 0;
            if (dateB < dateA) {
              return -1;
            }
            if (dateB > dateA) {
              return 1;
            }
            return 0;
          })
          .sort((a, b) => b.live - a.live);
        allChannels = [...sorted];
        channels = filterChannels(allChannels, $showOnlyMyChannels, $channelFilterText);
      },
      (error) => {
        console.log(error.message);
      },
    );
  };

  const onNewChatClicked = () => {
    createChannelOpen = !createChannelOpen;
  };

  const onCreateChannel = async (e) => {
    isCreatingChannel = true;
    const res = await addChannel(e.detail);
    isCreatingChannel = false;
    createChannelOpen = false;
    if (res) {
      if (e.detail.multichannel) {
        await setMultichannelChatConfig(e.detail.multichannel, res.id, {
          chatId: res.id,
          archived: false,
        });
      }
      navigate(`/chat/edit/${res.id}`);
    }
  };

  const onCancelClicked = () => {
    createChannelOpen = !createChannelOpen;
  };

  const onChannelClicked = (e) => {
    dispatch('channelclicked', { channel: e.detail.channel });
  };

  const onFiltersUpdated = (e) => {
    channels = [];
    channels = filterChannels(allChannels, $showOnlyMyChannels, $channelFilterText);
  };

  const filterChannels = (channelsToFilter, showOnlyMine, textFilter) => {
    return channelsToFilter
      .filter((c) => (showOnlyMine ? c.createdBy === $user.uid : true))
      .filter((c) =>
        $selectedChannelTypeFilter.includes('all')
          ? true
          : $selectedChannelTypeFilter.includes(c.category),
      )
      .filter((c) => (textFilter ? c.name.toUpperCase().includes(textFilter.toUpperCase()) : true));
  };
</script>

<div class="channels-container">
  <header>
    {#if standAlone}
      <a href="/" use:link>
        <img class="logo" src="/assets/tv2-logo.svg" alt="" />
      </a>
    {/if}
    <h3 class:stand-alone={standAlone}>{standAlone ? 'Chat' : 'Chat-rom'}</h3>
    <div class="btn-container">
      <button class="new-chat-btn" on:click={onNewChatClicked}>+ Ny chat</button>
      <Link to="/chat/published">
        <span class="material-icons"> open_in_new </span>
      </Link>
    </div>
  </header>
  <div class="filter">
    <Filter on:filtersupdated={onFiltersUpdated} on:showarchive={listenToChannelData} />
  </div>
  {#if $showArchivedChannels}
    <div class="archived-header" in:fade>
      <p>Arkiverte chat-rom</p>
    </div>
  {/if}
  <div class="channels">
    <ChannelsList {channels} on:channelclicked={onChannelClicked} />
  </div>
</div>

<CreateChannel
  open={createChannelOpen}
  on:ok={onCreateChannel}
  on:cancel={onCancelClicked}
  {isCreatingChannel}
/>

<style src="./channels.scss">
</style>
